import React from 'react';
import '../../loading.css'

const Loading = () => {
    return ( 
        <div className="parentLoading">
            <div className="loading">Loading</div>
        </div>
     );
}
 
export default Loading;